import {
  AuditOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Modal,
  Row,
  Spin,
  Table,
  Typography,
  Upload
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { useHistory, useParams } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { instanceRef } from '../../utils/axios';

import CardDocumentPreview360 from '../../components/CardDocumentPreview360';
import Image360 from '../../components/Image360';
import MapView from '../../components/MapView';
import { CONFIG } from '../../constants';
import { errorHandler, formatCelular } from '../../utils';
import { formatoMonedaGenerico } from '../../utils/converters';

const { Title } = Typography;

const SiniestroView = () => {
  const { token } = useParams();
  const [siniestro, setSiniestro] = useState();
  const [documentos, setDocumentos] = useState();
  const [fotosDocumentos, setFotosDocumentos] = useState();
  const [loading, setLoading] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [dialogConfig, setDialogConfig] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [zoomMap] = useState(15);
  const [marcadoMap] = useState(true);
  const history = useHistory();

  const columnsTerceros = [
    {
      title: 'Nombres',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Nro. Contacto',
      dataIndex: 'celular',
      key: 'celular',
      render: (_, record) => {
        if (record.celular) {
          return `+595${formatCelular(record.celular)}`;
        }
        return '';
      }
    },
    {
      title: 'Datos Adicionales',
      dataIndex: 'datos_adicionales',
      key: 'datos_adicionales',
      render: (_, record) => {
        if (record.datos_adicionales.datos) {
          return record.datos_adicionales.datos;
        }
        return '';
      }
    },
    {
      title: 'Chapa',
      dataIndex: 'chapa',
      key: 'chapa',
      render: (_, record) => {
        if (record.datos_adicionales.chapa) {
          return record.datos_adicionales.chapa;
        }
        return '';
      }
    }
  ];

  const columns = [
    {
      title: 'Nombres',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Nro. Contacto',
      dataIndex: 'celular',
      key: 'celular',
      render: (_, record) => {
        if (record.celular) {
          return `+595${formatCelular(record.celular)}`;
        }
        return '';
      }
    }
  ];

  function onDocumentLoadSuccess() {
    setNumPages(numPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getSiniestroFiles = async () => {
    setLoading(true);
    try {
      const files = await instanceRef.instance.get(`/siniestro/files/${token}`);
      const baseURL = CONFIG.URL_BASE;
      const docs = files.data.data.map((item) => ({
        ...item,
        url: `${baseURL}/siniestro/file/${token}?id=${item.id}`
      }));
      setFotosDocumentos(docs.filter((e) => !e.descripcion.includes('pdf')));
      setDocumentos(docs.filter((e) => e.descripcion.includes('pdf')));
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const columnsConsulta = [
    {
      title: 'Sección',
      dataIndex: ['seccion'],
      key: ['seccion']
    },
    {
      title: 'Nro. Póliza',
      dataIndex: ['nro_poliza'],
      key: ['nro_poliza']
    },
    {
      title: 'Endoso',
      dataIndex: ['endoso'],
      key: ['endoso']
    },
    {
      title: 'Artículo',
      dataIndex: ['articulo'],
      key: ['articulo']
    },
    {
      title: 'Fecha y Hora',
      dataIndex: ['fecha_hora'],
      key: ['fecha_hora'],
      render: (_, record) => {
        return record.fecha_hora
          ? moment(record.fecha_siniestro).format('DD/MM/YYYY HH:mm')
          : 'Sin fecha';
      }
    },
    {
      title: 'Nombre declarante',
      dataIndex: ['nombre_declarante'],
      key: ['nombre_declarante']
    },
    {
      title: 'Tiene denuncia',
      dataIndex: ['tiene_denuncia'],
      key: ['tiene_denuncia']
    },
    {
      title: 'Año',
      dataIndex: ['anho'],
      key: ['anho']
    },
    {
      title: 'Número',
      dataIndex: ['numero'],
      key: ['numero']
    },
    {
      title: 'Parcial Siniestro',
      dataIndex: ['parcial_siniestro'],
      key: ['parcial_siniestro']
    },
    {
      title: 'Última estimación',
      dataIndex: ['ultima_estimacion'],
      key: ['ultima_estimacion'],
      render: (_, record) => {
        const { moneda_simbolo, ultima_estimacion } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, ultima_estimacion);
      }
    },
    {
      title: 'Estado',
      dataIndex: ['estado'],
      key: ['estado']
    },
    {
      title: 'Liquidado',
      dataIndex: ['liquidado'],
      key: ['liquidado']
    },
    {
      title: 'Fecha de Liquidación',
      dataIndex: ['fecha_liquidacion'],
      key: ['fecha_liquidacion'],
      render: (_, record) => {
        return record.fecha_liquidacion
          ? moment(record.fecha_siniestro).format('DD/MM/YYYY')
          : 'Sin fecha';
      }
    }
  ];

  const columnsConsultaDetalle = [
    {
      title: 'Nro. orden',
      dataIndex: ['nro_orden'],
      key: ['nro_orden']
    },
    {
      title: 'Fecha',
      dataIndex: ['fecha'],
      key: ['fecha'],
      render: (_, record) => {
        return record.fecha
          ? moment(record.fecha).format('DD/MM/YYYY')
          : 'Sin fecha';
      }
    },
    {
      title: 'Tipo orden',
      dataIndex: ['tipo_orden'],
      key: ['tipo_orden']
    },
    {
      title: 'Proveedor',
      dataIndex: ['proveedor'],
      key: ['proveedor']
    },
    {
      title: 'Gravada',
      dataIndex: ['gravada'],
      key: ['gravada'],
      render: (_, record) => {
        const { moneda_simbolo, gravada } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, gravada);
      }
    },
    {
      title: 'Exenta',
      dataIndex: ['exenta'],
      key: ['exenta'],
      render: (_, record) => {
        const { moneda_simbolo, exenta } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, exenta);
      }
    },
    {
      title: 'Coaseguro',
      dataIndex: ['coaseguro'],
      key: ['coaseguro'],
      render: (_, record) => {
        const { moneda_simbolo, coaseguro } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, coaseguro);
      }
    },
    {
      title: 'Descuento',
      dataIndex: ['descuento'],
      key: ['descuento'],
      render: (_, record) => {
        const { moneda_simbolo, descuento } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, descuento);
      }
    },
    {
      title: 'Descuento franquicia',
      dataIndex: ['descuento_franquicia'],
      key: ['descuento_franquicia'],
      render: (_, record) => {
        const { moneda_simbolo, descuento_franquicia } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, descuento_franquicia);
      }
    },
    {
      title: 'IVA',
      dataIndex: ['iva'],
      key: ['iva'],
      render: (_, record) => {
        const { moneda_simbolo, iva } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, iva);
      }
    },
    {
      title: 'Total',
      dataIndex: ['total'],
      key: ['total'],
      render: (_, record) => {
        const { moneda_simbolo, total } = record;
        const moneda = {
          codigo: moneda_simbolo === 'Gs.' ? 'gs' : 'usd',
          simbolo: moneda_simbolo
        };
        return formatoMonedaGenerico(moneda, total);
      }
    }
  ];

  const getSiniestroData = () => {
    setLoading(true);
    instanceRef.instance
      .get(`/siniestro/${token}`)
      .then((res) => {
        setSiniestro(res.data.data);
        getSiniestroFiles();
      })
      .catch((err) => {
        errorHandler(err, err.message);
      });
    setLoading(false);
  };

  const consultarAviso = async () => {
    setLoading(true);
    try {
      const datos = await instanceRef.instance.get(
        `/siniestro/consultar-aviso/${token}`
      );

      await getSiniestroData();
      return datos;
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
    return null;
  };

  useEffect(() => {
    getSiniestroData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
        {siniestro && (
          <Card
            title={`Siniestro Nro.: ${siniestro.id} - ${siniestro.poliza.producto.descripcion}`}
            style={{ textAlign: 'left' }}
          >
            <div style={{ marginBottom: '15px' }}>
              <Button
                type="link"
                icon={<FileTextOutlined />}
                size="middle"
                onClick={() =>
                  handleOpenUrl(`/polizas/${siniestro.poliza.token}`)
                }
              >
                Poliza
              </Button>
              <Button
                type="link"
                icon={<FileDoneOutlined />}
                size="middle"
                onClick={() =>
                  handleOpenUrl(
                    `/solicitudes/${siniestro.poliza.solicitud.token}`
                  )
                }
              >
                Solicitud
              </Button>
              {siniestro.poliza.producto.codigo === 1 && (
                <Button
                  type="link"
                  icon={<AuditOutlined />}
                  size="middle"
                  onClick={() =>
                    handleOpenUrl(
                      `/inspecciones/edit/${siniestro.poliza.solicitud.inspeccion.token}`
                    )
                  }
                >
                  Inspección
                </Button>
              )}
              <Button
                type="link"
                icon={<FileSearchOutlined />}
                size="middle"
                onClick={() => handleOpenUrl(``)}
              >
                Peritaje
              </Button>
              <Button
                type="link"
                icon={<FileSearchOutlined />}
                size="middle"
                onClick={() => consultarAviso()}
              >
                Consultar Aviso
              </Button>
            </div>
            <div>
              <Descriptions
                title="Datos del Accidente"
                style={{ textAlign: 'left', paddingBottom: 40 }}
                bordered
                size="small"
                column={{ md: 2, sm: 1, xs: 1 }}
              >
                <Descriptions.Item
                  label="Fecha Ocurrencia"
                  labelStyle={{ width: '15em' }}
                >
                  {siniestro.fecha_siniestro
                    ? moment(siniestro.fecha_siniestro).format('DD/MM/YYYY')
                    : 'Sin fecha'}
                </Descriptions.Item>
                <Descriptions.Item label="Hora Ocurrencia">
                  {siniestro.fecha_siniestro
                    ? moment(siniestro.fecha_siniestro).format('HH:mm')
                    : 'Sin hora'}
                </Descriptions.Item>
                <Descriptions.Item label="Circunstancia de Ocurrencia" span={2}>
                  {siniestro.circunstancia_ocurrencia}
                </Descriptions.Item>
                {(siniestro?.poliza?.producto.codigo === 4 ||
                  siniestro?.poliza?.producto.codigo === 5 ||
                  siniestro?.poliza?.producto.codigo === 6) && (
                  <>
                    <Descriptions.Item label="Detalle de Daños" span={2}>
                      {siniestro.detalles.danios_inmueble}
                    </Descriptions.Item>
                    <Descriptions.Item label="Departamento">
                      {
                        siniestro.poliza?.solicitud?.inmueble?.departamento
                          ?.descripcion
                      }
                    </Descriptions.Item>
                    <Descriptions.Item label="Distrito">
                      {siniestro.poliza?.solicitud?.inmueble?.descripcion}
                    </Descriptions.Item>
                    <Descriptions.Item label="Domicilio">
                      {siniestro.poliza?.solicitud?.inmueble?.domicilio}
                    </Descriptions.Item>
                  </>
                )}
                {(siniestro?.poliza?.producto.codigo === 2 ||
                  siniestro?.poliza?.producto.codigo === 3) && (
                  <>
                    <Descriptions.Item label="Descripción de Lesiones" span={2}>
                      {siniestro.detalles.lesiones}
                    </Descriptions.Item>
                    <Descriptions.Item label="Departamento">
                      {siniestro.departamento?.descripcion}
                    </Descriptions.Item>
                    <Descriptions.Item label="Distrito">
                      {siniestro.distrito?.descripcion}
                    </Descriptions.Item>
                    <Descriptions.Item label="Lugar del siniestro">
                      {siniestro.domicilio}
                    </Descriptions.Item>
                  </>
                )}
                {(siniestro?.poliza?.producto.codigo === 1 ||
                  siniestro?.poliza?.producto.codigo === 7) && (
                  <>
                    <Descriptions.Item label="Daños del Vehículo" span={2}>
                      {siniestro.detalles.danios_vehiculo}
                    </Descriptions.Item>
                    <Descriptions.Item label="Nombre del Conductor">
                      {siniestro.detalles.nombre_conductor}
                    </Descriptions.Item>
                    <Descriptions.Item label="Velocidad de Circulación">
                      {siniestro.velocidad_circulacion}km/h
                    </Descriptions.Item>
                    <Descriptions.Item label="Departamento">
                      {siniestro.departamento?.descripcion}
                    </Descriptions.Item>
                    <Descriptions.Item label="Distrito">
                      {siniestro.distrito?.descripcion}
                    </Descriptions.Item>
                    <Descriptions.Item label="Lugar del siniestro">
                      {siniestro.domicilio}
                    </Descriptions.Item>
                  </>
                )}
              </Descriptions>
              {(siniestro.poliza.solicitud.inmueble?.latitud ||
                siniestro.latitud) && (
                <MapView
                  coordenadas={{
                    lat:
                      siniestro.poliza.solicitud.inmueble?.latitud ||
                      siniestro.latitud,
                    lng:
                      siniestro.poliza.solicitud.inmueble?.longitud ||
                      siniestro.longitud
                  }}
                  zoom={zoomMap}
                  marker={marcadoMap}
                />
              )}
              <br />
              <Descriptions
                title="Datos del Declarante"
                style={{ textAlign: 'left', paddingBottom: 40 }}
                bordered
                size="small"
                column={{ md: 2, sm: 1, xs: 1 }}
              >
                <Descriptions.Item
                  label="Nombre y apellido"
                  labelStyle={{ width: '15em' }}
                >
                  {siniestro.detalles.declarante.nombres}
                </Descriptions.Item>
                <Descriptions.Item
                  label="Nro. de contacto"
                  labelStyle={{ width: '15em' }}
                >
                  {siniestro.detalles.declarante.celular}
                </Descriptions.Item>
                <Descriptions.Item
                  label="Correo"
                  labelStyle={{ width: '15em' }}
                >
                  {siniestro.detalles.declarante.correo}
                </Descriptions.Item>
              </Descriptions>
              {(siniestro?.poliza?.producto.codigo === 1 ||
                siniestro?.poliza?.producto.codigo === 7) && (
                <>
                  <Title level={5} style={{ textAlign: 'left' }}>
                    Datos de Personas Involucradas
                  </Title>
                  <span style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    Terceros
                  </span>
                  {!siniestro.tiene_terceros ||
                  siniestro.personaInvolucrada.filter((item) =>
                    item.tipo.includes('TERCERO')
                  ).length < 1 ? (
                    <span style={{ justifyContent: 'start', display: 'flex' }}>
                      No hubo terceros
                    </span>
                  ) : (
                    <Table
                      fixed
                      scroll={false}
                      style={{ width: '100%' }}
                      bordered
                      dataSource={siniestro.personaInvolucrada.filter((item) =>
                        item.tipo.includes('TERCERO')
                      )}
                      columns={columnsTerceros}
                      pagination={false}
                      rowKey={(record) => record.id}
                      size="small"
                    />
                  )}
                  <br />
                  <span style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    Lesionados
                  </span>
                  {!siniestro.tiene_lesionados ||
                  siniestro.personaInvolucrada.filter((item) =>
                    item.tipo.includes('LESIONADO')
                  ).length < 1 ? (
                    <span style={{ justifyContent: 'start', display: 'flex' }}>
                      No hubo lesionados
                    </span>
                  ) : (
                    <Table
                      fixed
                      scroll={false}
                      style={{ width: '100%' }}
                      bordered
                      dataSource={siniestro.personaInvolucrada.filter((item) =>
                        item.tipo.includes('LESIONADO')
                      )}
                      columns={columns}
                      pagination={false}
                      rowKey={(record) => record.id}
                      size="small"
                    />
                  )}
                  <br />
                  <span style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    Testigos
                  </span>
                  {!siniestro.tiene_testigos ||
                  siniestro.personaInvolucrada.filter((item) =>
                    item.tipo.includes('TESTIGO')
                  ).length < 1 ? (
                    <span style={{ justifyContent: 'start', display: 'flex' }}>
                      No hubo testigos
                    </span>
                  ) : (
                    <Table
                      fixed
                      scroll={false}
                      style={{ width: '100%' }}
                      bordered
                      dataSource={siniestro.personaInvolucrada.filter((item) =>
                        item.tipo.includes('TESTIGO')
                      )}
                      columns={columns}
                      pagination={false}
                      rowKey={(record) => record.id}
                      size="small"
                    />
                  )}
                  <br />
                  <span style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    Autoridad interviniente
                  </span>
                  {!siniestro.intervino_autoridad ? (
                    <span style={{ justifyContent: 'start', display: 'flex' }}>
                      No intervino autoridad
                    </span>
                  ) : (
                    <span style={{ justifyContent: 'start', display: 'flex' }}>
                      {siniestro.detalles.autoridad}
                    </span>
                  )}
                </>
              )}
              <br />
              <Title level={5} style={{ textAlign: 'left' }}>
                Fotografías
              </Title>
              {fotosDocumentos && !fotosDocumentos.length && <p>Sin datos</p>}
              <Row gutter={[16, 16]} justify="center" align="middle">
                {fotosDocumentos &&
                  fotosDocumentos.map((imagen) => (
                    <Col key={imagen.url}>
                      <div>
                        <Upload
                          name="avatar"
                          listType="picture-card"
                          className={`avatar-uploader success'`}
                          showUploadList={false}
                          disabled
                        >
                          <Image360
                            style={{
                              width: 'auto !important',
                              borderColor: 'red',
                              height: '40%'
                            }}
                            src={imagen.url}
                            alt="avatar"
                          />
                        </Upload>
                      </div>
                    </Col>
                  ))}
              </Row>
              <Title level={5} style={{ textAlign: 'left' }}>
                Documentos
              </Title>
              {documentos && !documentos.length && <p>Sin datos</p>}
              <div>
                <Row gutter={[16, 16]} justify="center" align="middle">
                  {documentos &&
                    documentos.map((doc) => (
                      <Col>
                        <CardDocumentPreview360
                          key={doc.url}
                          cardProps={{
                            onClick: () => {
                              setDialogConfig({
                                open: true,
                                content: doc.url,
                                title: ''
                              });
                            }
                          }}
                          documentProps={{
                            file: doc.url,
                            onLoadSuccess: onDocumentLoadSuccess
                          }}
                        />
                      </Col>
                    ))}
                </Row>{' '}
                <Modal
                  bodyStyle={{ padding: 0, paddingBottom: 20 }}
                  style={{ maxWidth: 1000 }}
                  className="modal-header-document"
                  centered
                  open={dialogConfig.open}
                  afterClose={() =>
                    setDialogConfig({
                      open: false,
                      content: undefined,
                      title: ''
                    })
                  }
                  onCancel={() =>
                    setDialogConfig({
                      open: false,
                      content: undefined,
                      title: ''
                    })
                  }
                  footer={null}
                  width="90%"
                >
                  <div>
                    {dialogConfig.content && (
                      <SizeMe>
                        {({ size }) => (
                          <Document
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading={<Spin />}
                            file={dialogConfig.content}
                          >
                            <Page
                              key={`page_${currentPage + 1}`}
                              pageNumber={currentPage + 1}
                              width={size.width ? size.width : 1}
                            />
                            <div style={{ textAlign: 'center' }}>
                              <Button
                                type="link"
                                onClick={() => previousPage()}
                                disabled={currentPage === 0}
                              >
                                <LeftOutlined />
                                Anterior
                              </Button>
                              Pág. {currentPage + 1} de {numPages}
                              <Button
                                type="link"
                                onClick={() => nextPage()}
                                disabled={currentPage + 1 === numPages}
                              >
                                Siguiente
                                <RightOutlined />
                              </Button>
                            </div>
                          </Document>
                        )}
                      </SizeMe>
                    )}
                  </div>
                </Modal>
                <Row style={{ margin: '0px 30px 0px 30px' }}>
                  <Col
                    xs={24}
                    sm={24}
                    style={{ margin: '10px', justifyContent: 'space-between' }}
                  >
                    {' '}
                  </Col>
                </Row>
              </div>
              <br />
              <Title level={5} style={{ textAlign: 'left' }}>
                Consulta de Aviso
              </Title>
              <div style={{ overflowX: 'auto' }}>
                <Table
                  scroll
                  style={{ width: 'fit-content' }}
                  bordered
                  dataSource={
                    (siniestro?.siniestroConsultaAviso && [
                      siniestro?.siniestroConsultaAviso
                    ]) ||
                    []
                  }
                  columns={columnsConsulta}
                  pagination={false}
                  rowKey={(record) => record?.id}
                  size="small"
                />
              </div>
              <br />
              <Title level={5} style={{ textAlign: 'left' }}>
                Órdenes
              </Title>
              <div style={{ overflowX: 'auto' }}>
                <Table
                  scroll
                  style={{ width: 'fit-content' }}
                  bordered
                  dataSource={
                    (siniestro?.siniestroConsultaAviso?.ordenes.length > 0 &&
                      siniestro?.siniestroConsultaAviso?.ordenes) ||
                    []
                  }
                  columns={columnsConsultaDetalle}
                  pagination={false}
                  rowKey={(record) => record?.id}
                  size="small"
                />
              </div>
            </div>
          </Card>
        )}
      </Spin>
    </ResponsiveContainer>
  );
};

export default SiniestroView;
